import type { PagedResultDto } from "@services/dto/pagedResultDto"
import townShipService from "@services/master-data/townShipService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class TownShipStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await townShipService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.getListTownShip()
  }

  @action
  async newTownShip() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await townShipService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
    appDataStore.getListTownShip()
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await townShipService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await townShipService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default TownShipStore
